import { render, staticRenderFns } from "./Flat.vue?vue&type=template&id=79e7e620&scoped=true"
import script from "./Flat.vue?vue&type=script&lang=js"
export * from "./Flat.vue?vue&type=script&lang=js"
import style0 from "./Flat.vue?vue&type=style&index=0&id=79e7e620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7e620",
  null
  
)

export default component.exports